import { Contact } from "../_types/internalContacts.types";
import { getContactId } from "./internalContacts.utils";

type MessageEntity = {
  type?: string;
  uid?: string;
  id?: string | number;
};

export const filterEmployeeCompanyContacts = (contacts: Contact[], companyId?: number | null): Contact[] => {
  if (!companyId) {
    return contacts.filter((contact) => contact.type === "company");
  }

  return contacts.filter(
    (contact) => contact.type === "company" && Number(contact.id) === Number(companyId),
  );
};

export const resolveUnifiedContactIdFromEntity = (
  entity: MessageEntity,
  contacts: Contact[],
  role: string,
  companyId?: number,
): string | number | null => {
  if (!entity?.type) return null;

  if (role === "employee") {
    if (entity.type === "company" && entity.id != null) {
      return entity.id;
    }

    if (entity.type === "user" || entity.type === "workforce") {
      const companyContact = contacts.find(
        (contact) =>
          contact.type === "company" &&
          (!companyId || Number(contact.id) === Number(companyId)),
      );
      return companyContact ? getContactId(companyContact) : null;
    }

    return null;
  }

  if (entity.type === "workforce" && entity.uid) {
    const workforceContact = contacts.find(
      (contact) => contact.type === "workforce" && String(contact.uid) === String(entity.uid),
    );
    return workforceContact ? getContactId(workforceContact) : entity.uid;
  }

  if (entity.type === "company" && entity.id != null) {
    return entity.id;
  }

  if (entity.type === "user" && entity.uid) {
    return entity.uid;
  }

  return null;
};
